export const dashboardStats = [
  {
    id: "active-moves",
    label: "Active Moves Today",
    value: "14",
    delta: "+3",
    deltaTrend: "up",
    icon: "ri-truck-line",
    iconBg: "bg-ink-900",
    iconColor: "text-white",
    suffix: "vs. yesterday",
  },
  {
    id: "revenue",
    label: "Revenue This Month",
    value: "$148,250",
    delta: "+12.4%",
    deltaTrend: "up",
    icon: "ri-money-dollar-circle-line",
    iconBg: "bg-cream-100",
    iconColor: "text-ink-700",
    suffix: "vs. last month",
  },
  {
    id: "bookings",
    label: "New Bookings",
    value: "27",
    delta: "+8",
    deltaTrend: "up",
    icon: "ri-calendar-event-line",
    iconBg: "bg-cream-100",
    iconColor: "text-ink-700",
    suffix: "this week",
  },
  {
    id: "crew-on-clock",
    label: "Crew On The Clock",
    value: "23 / 38",
    delta: "60% active",
    deltaTrend: "flat",
    icon: "ri-team-line",
    iconBg: "bg-cream-100",
    iconColor: "text-ink-700",
    suffix: "live status",
  },
];

export const weeklyRevenue = [
  { day: "Mon", value: 18400 },
  { day: "Tue", value: 22100 },
  { day: "Wed", value: 17800 },
  { day: "Thu", value: 25600 },
  { day: "Fri", value: 31200 },
  { day: "Sat", value: 28900 },
  { day: "Sun", value: 14300 },
];

export const projectStatusBreakdown = [
  { label: "Scheduled", count: 42, color: "bg-ink-300" },
  { label: "In Progress", count: 14, color: "bg-brand-500" },
  { label: "Completed", count: 187, color: "bg-ink-800" },
  { label: "On Hold", count: 5, color: "bg-ink-200" },
];